import React, { useState, useEffect, Fragment, useMemo } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { FileCopySharp, Message } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import moment from 'moment';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsFindBy, wsPost } from 'services/WService.js';

//modal
import Modal from './Modal';
import Modal2 from './ModalReplace';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { wsUpdate } from 'services/WService';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'baseline',
  },
  headerCard: {
    fontSize: '.9em',
    '& .totals': {
      marginLeft: '20px',
      fontWeight: 'bold',
      color: 'black',
    },
  },
  loader: {
    marginLeft: '20px',
  },
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'Periodo', accessor: 'Periodo', width: 100 },
  { Header: 'Cód Proveedor', accessor: 'CardCode' },  
  { Header: 'Nom Prov', accessor: 'CardName' },  
  // { Header: 'Cód Marcas', accessor: 'mark_code' },
  { Header: 'Marcas', accessor: 'description_logi_mark' },
  { Header: 'Cód zonas', accessor: 'zone_code', width: 100 },
  { Header: 'Zonas', accessor: 'description_base_zone', width: 100},
  { Header: 'Tipo', accessor: 'tipo' },
  { Header: 'Supervisor', accessor: 'supervisor' },
  { Header: 'Cuota', accessor: 'quota' },
  { Header: 'Peso', accessor: 'peso', width: 100, excelEnabled: false },
  { Header: 'Peso', accessor: 'peso_string', hidden: true },
  { Header: 'Com de importe', accessor: 'importe_comision', excelEnabled: false },
  { Header: 'Com de importe', accessor: 'importe_comision_string', hidden: true },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Colgate(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [model2, setOpen2] = useModal();
  const [notify, showNotify] = useToasty();
  const [comisiones, setComisiones] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);
  const [valueSearch, setValueSearch] = useState({});
  const [selectedType, setSelectedType] = useState(null);
  const [currentPeriod, setCurrentPeriod] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);

  const handleChange = (id, field, value) => {
    const index = comisiones.findIndex((item) => item.id == id);
    comisiones[index][field] = value;
    setComisiones([...comisiones]);
  };
  
  async function loadComisiones(filter) {
    setDataLoading(true);
    setIsDataReady(false);
    let response = await wsFindBy('sale/comisiones', filter);
    setDataLoading(false);
  
    if (response.success) {
      setComisiones(response.data);
      setIsDataReady(true);
      notifyWeight(response.data, filter);
    }
  }
  
  async function updateComisiones(id, field, value) {
    setDataLoading(true);
    let response = await wsUpdate('sale/comisiones', id, { [field]: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      console.log('Datos devueltos: ', response.data);
      loadComisiones(valueSearch);
      
    } else {
      showNotify(response.message, 'error');
    }
  }

  const totalComision = useMemo(() => {
    const total = comisiones.reduce((acc, comision) => acc + parseFloat(comision.importe_comision || 0), 0);
  
    return total.toFixed(2);
  }, [comisiones]);

  const pesoTotals = useMemo(() => {
    const totals = {};
  
    if (!isDataReady || (!valueSearch.tipo && !valueSearch.zone_code && !valueSearch.supervisor)) {
      return totals;
    }
  
    comisiones.forEach((comision) => {
      if (valueSearch.tipo && comision.tipo === valueSearch.tipo) {
        totals[comision.tipo] = (totals[comision.tipo] || 0) + parseFloat(comision.peso || 0);
      }
      if (valueSearch.zone_code && comision.zone_code === valueSearch.zone_code) {
        totals[comision.zone_code] =
          (totals[comision.zone_code] || 0) + parseFloat(comision.peso || 0);
      }
      if (valueSearch.supervisor && comision.supervisor === valueSearch.supervisor) {
        totals[comision.supervisor] =
          (totals[comision.supervisor] || 0) + parseFloat(comision.peso || 0);
      }
    });
  
    return Object.keys(totals).reduce((acc, key) => {
      acc[key] = totals[key].toFixed(2);
      return acc;
    }, {});
  }, [comisiones, isDataReady, valueSearch]);

  function notifyWeight(data, filter) {
    const isTypeProveedorFiltered = !!filter.tipo;
    const isZoneFiltered = !!filter.zone_code;
    const isMarkFiltered = !!filter.logi_mark_id;
    const isProviderFiltered = !!filter.base_business_partner_id;
    const isSupervisorFiltered = !!filter.supervisor;
  
    // Mostrar notificaciones solo si ambos filtros relevantes están activos
    if (isTypeProveedorFiltered && isZoneFiltered && isSupervisorFiltered && !isMarkFiltered && !isProviderFiltered) {
      const totals = {};
  
      data.forEach((comision) => {
        if (filter.tipo && comision.tipo === filter.tipo) {
          totals[comision.tipo] = (totals[comision.tipo] || 0) + parseFloat(comision.peso || 0);
        }
        if (filter.zone_code && comision.zone_code === filter.zone_code) {
          totals[comision.zone_code] =
            (totals[comision.zone_code] || 0) + parseFloat(comision.peso || 0);
        }
        if (filter.supervisor && comision.supervisor === filter.supervisor) {
          totals[comision.supervisor] =
            (totals[comision.supervisor] || 0) + parseFloat(comision.peso || 0);
        }
      });
  
      const pesoCombinado = Math.max(
        totals[filter.tipo] || 0,
        totals[filter.zone_code] || 0,
        totals[filter.supervisor] || 0
      );
  
      if (pesoCombinado === 100) {
        showNotify(`El peso total es del 100%.`, 'success');
      } else if (pesoCombinado > 100) {
        showNotify(`El peso total excede el 100% (${pesoCombinado}%).`, 'error');
      } else {
        showNotify(`El peso total es menor al 100% (${pesoCombinado}%).`, 'warning');
      }
    }
  }

  async function transferirRegistros(sourcePeriodo, targetPeriodo) {
    setDataLoading(true);
    let response = await wsPost('sale/comisiones/transferir-registros', {
      SourcePeriodo: sourcePeriodo,
      TargetPeriodo: targetPeriodo,
    });
    setDataLoading(false);

    if (response.success) {
      showNotify(response.message);
      console.log('Transferencia exitosa: ', response.data);
      loadComisiones(valueSearch);
    } else {
      showNotify(response.message, 'error');
      console.error('Error al transferir registros: ', response);
    }
  }

  const handleFilterChange = (value) => {
    const period = parseInt(moment(value.Periodo).format('YYYYMM'), 10);
    setCurrentPeriod(period);
  };

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => loadComisiones(valueSearch)}
        />
      ) : undefined}
      {model2.open ? (
        <Modal2 
          model={model2}
          setOpen={setOpen2}
          showNotify={showNotify}
          reload={() => loadComisiones(valueSearch)}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.SALE_COMISIONES_STORE}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
              <div className={classes.cardIconTitle}>Listado de comisiones
                <div className={classes.headerCard}>
                  {valueSearch.tipo || valueSearch.zone_code || valueSearch.supervisor ? (
                    <>
                      {valueSearch.tipo && valueSearch.zone_code && valueSearch.supervisor ? (
                        <span className="totals">Peso: {Math.max(pesoTotals[valueSearch.tipo], pesoTotals[valueSearch.zone_code], pesoTotals[valueSearch.supervisor])|| '0.00'}%</span>
                      ) : valueSearch.tipo && valueSearch.zone_code ? (
                        <span className="totals">Peso: {Math.max(pesoTotals[valueSearch.tipo], pesoTotals[valueSearch.zone_code] )|| '0.00'}%</span>
                      ) : valueSearch.tipo && valueSearch.supervisor ? (
                        <span className="totals">Peso: {Math.max(pesoTotals[valueSearch.tipo], pesoTotals[valueSearch.supervisor] )|| '0.00'}%</span>
                      ) : valueSearch.zone_code && valueSearch.supervisor ? (
                        <span className="totals">Peso: {Math.max(pesoTotals[valueSearch.zone_code], pesoTotals[valueSearch.supervisor] )|| '0.00'}%</span>
                      ) : valueSearch.tipo ? (
                        <span className="totals">Peso tipo: {pesoTotals[valueSearch.tipo]|| '0.00'}%</span>
                      ) : valueSearch.supervisor ? (
                        <span className="totals">Peso Supervisor: {pesoTotals[valueSearch.supervisor]|| '0.00'}%</span>
                      ) : (
                        <span className="totals">Peso Zona: {pesoTotals[valueSearch.zone_code] || '0.00'}%</span>
                      )}
                    </>
                  ) : (<span className="totals">Peso: 0%</span>)}
                  <span className="totals">Total Comisión: {totalComision}</span>
                </div>
                <div className={classes.loader}>
                  {dataLoading && <LoadingSpinner />}
                </div>
            </div>
          </CardHeader>
          <CardBody>
            <FilterCustom
              getFilter={loadComisiones}
              getValueSearch={(value) => {
                setValueSearch(value);
                setSelectedType(value.tipo || null);
                handleFilterChange(value);
              }}
              date
              dateType="month"
              labelDate="Periodo"
              dateField="Periodo"
              typeProveedor
              provider
              mark
              zoneCode
              supervisorH
            />
            <Button
              color="danger"
              onClick={() => {
                const sourcePeriod = moment(currentPeriod.toString(), "YYYYMM").subtract(1, "month").format("YYYYMM");
                transferirRegistros(Number(sourcePeriod), currentPeriod);
              }}>
              Inicializar comisiones
            </Button>
            <Button
              color="info"
              onClick={() => {setOpen2(true);}}>
              Reemplazar supervisor
            </Button>
            <ReactTable
              excelName="listado_comisiones"
              formatDate="DD-MM-YYYY"
              defaultWidth={1300}
              columns={columns}
              data={comisiones.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard
                        permission={ConstantPermissions.SALE_COMISIONES_DELETED}
                      >
                        <ButtonDelete
                          entity="sale/comisiones"
                          id={item.id}
                          reload={() => {
                            setDataLoading(true);
                            loadComisiones(valueSearch).then(() => setDataLoading(false));
                          }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  Periodo: item.Periodo,
                  CardCode: item.CardCode,
                  CardName: item.CardName,
                  mark_code: item.mark_code,
                  description_logi_mark: item.description_logi_mark,
                  zone_code: item.zone_code,
                  description_base_zone: item.description_base_zone,
                  tipo: item.tipo ? (item.tipo === 'PD' ? 'Proveedores en desarrollo' : item.tipo === 'PP' ? 'Proveedores principales' : item.tipo) : '',
                  supervisor: item.supervisor,
                  base_supervisor_id: item.base_supervisor_id,
                  quota: item.quota,
                  peso_string: item.peso,
                  importe_comision_string: item.importe_comision,
                  peso: (
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_COMISIONES_UPDATE}
                      component={item.peso}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="peso"
                        margin="normal"
                        value={item.peso || ''}
                        onChange={(e) => handleChange(item.id, 'peso', e.target.value)}
                        onBlur={(e) => updateComisiones(item.id, 'peso', e.target.value)}
                      />
                    </AllowedGuard>
                  ),
                  importe_comision: (
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_COMISIONES_UPDATE}
                      component={item.importe_comision}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="importe_comision"
                        margin="normal"
                        value={item.importe_comision || ''}
                        onChange={(e) => handleChange(item.id, 'importe_comision', e.target.value)}
                        onBlur={(e) => updateComisiones(item.id, 'importe_comision', e.target.value)}
                      />
                    </AllowedGuard>
                  ),
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
